import React, { useEffect, useRef, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { useHistory } from "react-router-dom";
import './EglFamilyWebview.scss'
import { ssoAPIHelper } from "../services/SSOAPIHelper";
import { createAction } from "utils";

function EglFamilyWebview({ isLogin, familyBookingUrl, bookingAccess, error }) {
  const dispatch = useDispatch()
  const history = useHistory()
  const [bookingState, setBookingState] = useState('loading') // loading, ready, blocked, success, manual_blocked
  useEffect(() => {
    if (!isLogin) {
      const url = ssoAPIHelper.getLoginWebUri("zh-Hant", "/family_booking") + `&cancel_redirect_when_login_cancel=true`;
      window.location.href = url;
      return
    }
    dispatch(createAction("customization/getFamilyBookingList")())

    return () => {
      dispatch({ type: "customization/clearState" })
      console.log("return clean webview")
    };
  }
    , []
  );

  useEffect(() => {
    if (familyBookingUrl) {
      // history.goBack()
      setBookingState('ready')
      const timer = setTimeout(() => {
        handleOpen('blocked')
      }, 10000); // 10 seconds to auto open
      return () => clearTimeout(timer)
    }
  }, [familyBookingUrl, history])

  const handleOpen = (blockstate) => {
    console.log(blockstate)
    const newWindow = window.open(`${familyBookingUrl}?access_token=${bookingAccess}`, '_blank')
    if (newWindow) {
      history.goBack()
      setBookingState('success')
    } else {
      setBookingState(blockstate)
    }
  }

  const handleCopy = () => {
    const textToCopy = `${familyBookingUrl}?access_token=${bookingAccess}`;
    try {
      navigator.clipboard.writeText(textToCopy);
      alert('已複製到剪貼簿，請貼上到瀏覽器開啟');
    } catch (err) {
      console.error('copy failed:', err);
      alert('複製失敗，請手動複製：' + textToCopy);
    }
  };

  const renderContent = () => {
    switch (bookingState) {
      case 'loading':
      case 'ready':
        return <div className="egl-loader" />
      case 'blocked':
        return (
          <div style={{ textAlign: 'center', padding: '20px' }}>
            <p className='title-large'>彈出視窗被阻止</p>
            <p className='field-text'>您的瀏覽器阻止了自動彈出視窗。請：</p>
            <ol style={{ textAlign: 'left', display: 'inline-block' }}>
              <li className='field-text'>允許此網站的彈出窗口</li>
              <li className='field-text'>或點選下方按鈕手動開啟</li>
            </ol>
            <div style={{ marginTop: '20px' }}>
              <button
                onClick={() => handleOpen("manual_blocked")}
                className='content_button button-large'
                style={{ marginRight: '10px' }}
              >
                手動開啟預訂頁面
              </button>
            </div>
          </div>
        )
      case 'manual_blocked':
        return (
          <div style={{ textAlign: 'center', padding: '20px' }}>
            <p className='title-large'>手動開啟被阻止</p>
            <p className='field-text'>請點擊下面的按鈕複製鏈接，然後手動貼上到瀏覽器打開</p>
            <div style={{ marginTop: '20px' }}>
              <button
                onClick={handleCopy}
                className='content_button button-large'
                style={{ marginRight: '10px' }}
              >
                複製鏈接
              </button>
            </div>
          </div>
        )
      case 'success':
        return (
          <div style={{ textAlign: 'center', padding: '20px' }}>
            <p className='title-large'>預訂頁面已開啟</p>
          </div>
        )
      default:
        return <div className="egl-loader" />
    }
  }

  return (
    <div className='egl-loader-container'>
      {renderContent()}
      {error && <div style={{ textAlign: 'center', padding: '20px' }}><p className='title-large'>{error}</p></div>}
    </div>
  );
}

const mapStateToProps = (state) => ({
  isLogin: state.users.isLogin,
  familyBookingUrl: state.customization.familyBookingUrl,
  bookingAccess: state.customization.bookingAccess,
  error: state.customization.error,
});

export default connect(mapStateToProps)(EglFamilyWebview);
